@if (noticeHeadline) {
  <h2>{{ noticeHeadline }}</h2>
}
